import Typography, { TypographyOptions } from 'typography';

import OceanBeach from './ocean-beach';

function appendClassName(styles: any, className = 'markdown') {
  Object.keys(styles).forEach((k) => {
    const style = styles[k];
    // eslint-disable-next-line no-param-reassign
    delete styles[k];
    // eslint-disable-next-line no-param-reassign
    styles[`.${className} ${k}`] = style;
  });
  return styles;
}

const overrideStylesOrig = OceanBeach.overrideStyles as NonNullable<TypographyOptions['overrideStyles']>;

OceanBeach.overrideStyles = (verticalRhythm, options, styles) => {
  appendClassName(styles);
  const stylesOverridden = overrideStylesOrig(verticalRhythm, options, styles) as any;
  return appendClassName(stylesOverridden);
};

type TypeOverrideThemeStyles = NonNullable<TypographyOptions['overrideThemeStyles']>;

const overrideThemeStylesOrig = OceanBeach.overrideThemeStyles as TypeOverrideThemeStyles;

OceanBeach.overrideThemeStyles = (...args) => {
  // const type = typeof overrideThemeStylesOrig;
  // console.log({ type });
  const ret = overrideThemeStylesOrig?.(...args) || undefined;
  return ret;
};

// SutroTheme.scaleRatio = 5 / 2;

// disable normalize in favor of tailwind
OceanBeach.includeNormalize = false;

const typography = new Typography(OceanBeach);

// Hot reload typography in development.
// if (process.env.NODE_ENV !== `production`) {
//   typography.injectStyles();
// }

export default typography;
